export const MAX_DESKTOP_TITLE_LENGTH = 50;
export const MAX_MOBILE_TITLE_LENGTH = 35;
